// Navbar Dirty Fix

var slides = document.getElementsByClassName("site-nav__label");

function sabers() {
  document.location.href = 'https://saberforge.com/collections/custom-sabers';
}

function parts() {
  document.location.href = 'https://saberforge.com/collections/adaptive-saber-parts';
}

function acc() {
  document.location.href = 'https://saberforge.com/collections/general-accessories';
}

function elec() {
  document.location.href = 'https://saberforge.com/collections/electronics';
}

function cos() {
  document.location.href = 'https://saberforge.com/collections/all-cosplay';
}

function qck() {
  document.location.href = 'https://saberforge.com/collections/quick-ship';
}

function help() {
  document.location.href = 'https://help.saberforge.com/';
}

for (var i = 0; i < slides.length; i++) {
 
  if (slides[i].innerHTML === 'Sabers'){
   
    slides[i].parentElement.addEventListener("click", sabers)
  }
  if (slides[i].innerHTML === 'Adaptive Saber Parts'){
   
    slides[i].parentElement.addEventListener("click", parts)
  }
  if (slides[i].innerHTML === 'Accessories'){
    
    slides[i].parentElement.addEventListener("click", acc)
  }
  
  if (slides[i].innerHTML === 'Electronics'){
    
    slides[i].parentElement.addEventListener("click", elec)
  }
  if (slides[i].innerHTML === 'Quick Ship'){

    slides[i].parentElement.addEventListener("click", qck)
  }
  
  if (slides[i].innerHTML === 'Cosplay'){
   
    slides[i].parentElement.addEventListener("click", cos)
  }
    if (slides[i].innerHTML === 'Help'){
   
    slides[i].parentElement.addEventListener("click", help)
  }
}
// // this checks whether system dark mode is set 
// let systemInitiatedDark = window.matchMedia("(prefers-color-scheme: dark)"); 

// // this checks for session storage telling to override
// // console.log(systemInitiatedDark.matches)
// if (systemInitiatedDark.matches) {
//   document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust dark-rotate'></i>";
//   document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Light Mode";
// } else {
//   document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust light-rotate'></i>";
//   document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Dark Mode";
// }

// function prefersColorTest(systemInitiatedDark) {
//   if (systemInitiatedDark.matches) {
//     document.documentElement.setAttribute('data-theme', 'dark');		
//     document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust dark-rotate'></i>";
//     // this clears the session storage 
//     localStorage.setItem('theme', '');
//   } else {
//     document.documentElement.setAttribute('data-theme', 'light');
//     document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust light-rotate'></i>";
//     localStorage.setItem('theme', '');
//   }
// }

// systemInitiatedDark.addListener(prefersColorTest);

// function modeSwitcher() {
//   // it’s important to check for overrides again 
//   let theme = localStorage.getItem('theme');
//   // checks if reader selected dark mode 
//   if (theme === "dark") {
//     document.documentElement.setAttribute('data-theme', 'light');
//     localStorage.setItem('theme', 'light');
//     document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust light-rotate'></i>";
//     document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Dark Mode";
//     // checks if reader selected light mode 
//   }	else {
//     document.documentElement.setAttribute('data-theme', 'dark');
//     localStorage.setItem('theme', 'dark');
//     document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust dark-rotate'></i>";
//     document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Light Mode";
//   }
// }

// if (siteTheme === "dark") {

//   document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust dark-rotate'></i>";
//   document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Light Mode";
// } else if (siteTheme === "light") {
  
//   document.getElementById("theme-toggle").innerHTML = "<i class='fas fa-adjust light-rotate'></i>";
//   document.getElementsByClassName("mobile-theme-toggle")[0].innerHTML = "Dark Mode";
// }





$('.site-header__search-toggle').click(function() { 
//   console.log('scrolled')
});


function timeBanners() {
  setTimeout(function(){
    $( ".copy-container" ).addClass( "animate" );
    $( ".asp-hero-logo" ).addClass( "animate" );
    $( ".custom-finish-landing" ).addClass( "animate" );
    $( ".powder-logo" ).addClass( "animate" );
    $( ".asp-slide-1" ).addClass( "animate" );
  }, 350);
}

function timeASP() {
  setTimeout(function(){
    $( ".asp-hero-logo" ).addClass( "animate" );
  }, 450);
}

timeBanners();
timeASP()

let animateTime = 0

if (screen.width > 1025) {
	animateTime = 575;
} else {
  animateTime = 500;
};

$(window).scroll(function () {
  $('.spot-copy').each(function (index,element) {
    var imagePos = $(this).offset().top;
    var topOfWindow = $(window).scrollTop();
    if (imagePos < topOfWindow + animateTime) {
      $(this).addClass("animate"); 
    }
  });

  $('.spot-copy-reverse').each(function (index,element) {
    var imagePos = $(this).offset().top;
    var topOfWindow = $(window).scrollTop();
    if (imagePos < topOfWindow + animateTime) {
      $(this).addClass("animate"); 
    }
  });

});

$( ".site-nav__label:contains('Gaming')" ).parent().parent().hide();

$( ".mobile-nav__label:contains('Gaming')" ).parent().parent().hide();

// $( ".site-nav__label:contains('Features')" ).parent().parent().hide();

// $( ".mobile-nav__label:contains('Features')" ).parent().parent().hide();

jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    if ( ns.includes("noPreventDefault") ) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  }
};
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    if ( ns.includes("noPreventDefault") ) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  }
};
  

